<template>
    <AccountModal :modelValue="isRegistrationOpened" @update:modelValue="closeAccountModal" class="registration-modal">
        <RegistrationContent />
    </AccountModal>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import AccountModal from "@/account/components/shared/account-modal.vue";
import RegistrationContent from "./registration/registration-content.vue";

import useAuthenticationFlows, { authenticationStep } from "../composables/use-authentication-flows";

const { closeAccountModal } = useAuthenticationFlows();

const isRegistrationOpened = computed(
    () =>
        authenticationStep.value == "RegPersonal" ||
        authenticationStep.value == "RegVerPhone" ||
        authenticationStep.value == "RegPinLog" ||
        authenticationStep.value == "RegPinOk" ||
        authenticationStep.value == "RegNewPass"
);
</script>
